/* eslint-disable no-plusplus */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { desfazerConexao, selectLogin, fetchLoginAnonimo } from '../../app/slices/loginSlice';
import {
  fetchOcorrenciaInteracoes, postAtualizarVisualizadoInteracaoManifestacao, postAtualizarVisualizadoManifestacao, postInteragir, postOpinar,
} from '../../api/endpoints';
import { selecionarArquivo } from '../../app/slices/arquivosSlice';
import { abrirModalArquivo, abrirModalImpressaoZeladoria, selectModal } from '../../app/slices/modalSlice';
import { ReactComponent as AnexoSvg } from '../../assets/icons/anexo.svg';
import AudioPng from '../../assets/icons/audio.png';
import LikePng from '../../assets/icons/like.png';
import PdfPng from '../../assets/icons/pdf.png';
import ZipPng from '../../assets/icons/zip.png';
import RarPng from '../../assets/icons/rar.png';
import UnlikePng from '../../assets/icons/unlike.png';
import VideoPng from '../../assets/icons/video.png';
import {
  DataTexto,
  Divisor, FormFooter,
  Grid,
  Linha, ListaItem, ListaItemBody, ListaItemHeader,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import { replaceTags } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import GridBotao from '../GridBotao/GridBotao';
import { BotaoRps, PerguntaRespostaZeladoria } from './ListaZeladoriasEstilo';
import { getTotem } from '../../api/apiFactory';

const defaultValues = {
  Interacao: '',
  IdOuvidoria: '',
  LikeUnlike: '',
  Justificativa: '',
  Nota: '',
};
const ListaZeladorias = ({
  arquivos, id, secretaria, dataHora, assunto,
  bairro, descricao, andamentos, unidade, likeUnlike, status, onRefresh, endereco, numero, dataHoraCanceladoConcluido,
}) => {
  const [aberto, setAberto] = useState(false);
  const [like, setLike] = useState(true);
  const [unlike, setUnlike] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [listaInteracoes, setListaInteracoes] = useState(null);
  const dadosLogin = useSelector(selectLogin);
  const [values, setValues] = useState(defaultValues);
  const [fotos, setFotos] = useState([]);

  // numero de dias desde a criação do protocolo
  const numeroDeDias = dataHoraCanceladoConcluido ? (Date.now() - new Date(dataHoraCanceladoConcluido.split(' ')[0].split('/').reverse().join('-'))) / (1000 * 3600 * 24) : 0;

  const dispatch = useDispatch();
  const alert = useAlert();

  useEffect(() => {
    Promise.all([
      fetchOcorrenciaInteracoes(id),
    ]).then(([dadosInteracoes]) => {
      setListaInteracoes(dadosInteracoes);
    });
  }, []);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  const preencheRps = (e) => {
    e.parentElement.querySelectorAll('button').forEach((button, i) => {
      button.addEventListener('click', (f) => {
        for (let x = 0; x <= i; x++) {
          e.parentElement.querySelectorAll('button')[x].classList.add('clicked');
        }
        for (let j = 10; j > i; j--) {
          e.parentElement.querySelectorAll('button')[j].classList.remove('clicked');
        }
      });
    });
  };

  const removerArquivo = ({ path }) => {
    setFotos(fotos.filter((arq) => arq.path !== path));
  };

  const adicionarArquivo = async (arquivo) => {
    if (arquivo.length + arquivos.length > 10) {
      return (
        alert.error('Limite de 10 arquivos permitido.', { timeout: 5000 })
      );
    }

    const validarRepetidos = () => {
      const arquivoExiste = arquivo.map(({ path: arq }) => arquivos.length && arquivos.find(({ path }) => arq === path))[0];
      const caminhoRepetido = arquivoExiste && arquivo.map(({ path: arq }) => arquivos.length && arquivos.find(({ path }) => arq === path))[0].path;

      return caminhoRepetido;
    };

    if (validarRepetidos()) {
      return (
        alert.error('Você já subiu um arquivo com esse nome.', { timeout: 5000 })
      );
    }

    return (
      setFotos(fotos.concat(arquivo.map((file) => Object.assign(file, {
        preview: URL.createObjectURL(file),
      }))))
    );
  };

  const ExibirErroTamanhoArquivo = (arquivo) => {
    // Você deve estar se perguntando: "Por que não fez essa validação também no método de adição de arquivos, assim como as outras validações foram feitas (de quantidade de arquivos e nomes repetidos)?"
    // Resposta: No FormControl, tem um atributo "maxSize" com valor limite para 200MB, e quanto o limite atinge, esse atributo bloqueia a inserção do arquivo e nem sequer ativa o método de adição que criei, logo eu não consigo personalizar uma mensagem de erro.
    // Dito isso, eu adicionei um atributo "onDropRejected" que é ativado justamente quando algum arquivo da erro, e daí nele eu personalizo uma função para exibir a mensagem de erro para o tamanho do arquivo.
    // Temos o atributo "onDrop", que é acionado sempre ao soltar os arquivos, e ele está bloqueando a chamada do adicionarArquivos devido ao erro soltado no maxSize do formControl, e temos agora também o "onDropRejected", que será chamado justamente se um erro desse tipo for liberado (erros tratados automaticamente pelo componente, como o tamanho do arquivo);
    // No método adicionarArquivos a gente consegue controlar erros os quais não são conhecidos pelo compomente de drop, no caso são "erros" personalizados por nós, ou seja, regras, tal como o limite de 10 arquivos, e de não pode adicionar um arquivo repetido. Já um erro de tamanho de arquivo isso é controlado nativamente pelo atributo maxSize do componente dropzone;
    // Resumindo: Aquilo que não for um erro de fato, no caso for uma regra NOSSA, como limite de arquivos, tratamentos de nome do arquivo etc, a gente consegue tratar no método de adição, que é acionado pelo atributo "onDrop". Já erros nativos, como o tamanho limite imposto aos arquivos, a gente precisa adicionar o "onDropRejected" que justamente receberá em formato de array cada um dos arquivos que deram erro apenas.

    // Limite: 200MB. Isso foi definido no arquivo "FormControl", aqui eu estou apenas adicionando uma lógica para exibir uma mensagem de retorno pois o Dropzone não mostra erro algum.
    // OBS: Se eu inserir mais de um arquivo por vez e algum deles tiver menos de 200MB, este será adicionado corretamente, mas os outros não. Caso peçam para que não adicione NENHUM, eu preciso passar essa lógica também para o método "adicionar" acima.
    const MAX_FILE_SIZE = 200000000;

    const arquivosGrandes = arquivo.filter((item) => item.file.size > MAX_FILE_SIZE);

    if (arquivosGrandes.length === 1) {
      return alert.error('O tamanho máximo permitido para um arquivo é de 200MB.', { timeout: 5000 });
    }

    if (arquivosGrandes.length > 0) {
      const nomesArquivosGrandes = arquivosGrandes.map((item) => item.file.name).join(', ');
      return alert.error(`Os seguintes arquivos ultrapassam o tamanho máximo permitido de 200MB: ${nomesArquivosGrandes}.`, { timeout: 10000 });
    }

    return alert.error('Ocorreu um erro durante a inserção de arquivo. Confira o tipo dos arquivos a serem inseridos e tente novamente.', { timeout: 5000 });
  };

  const enviarInteracao = async () => {
    setCarregando(true);

    const resposta = await postInteragir({
      ...values,
      IdOuvidoria: id,
      anexos: fotos,
    });

    if (resposta.Error) {
      setCarregando(false);
      return alert.error('Por favor, preencha a interação para continuar.', { timeout: 5000 });
    }

    Promise.all([
      fetchOcorrenciaInteracoes(id),
    ]).then(([dadosInteracoes]) => {
      setListaInteracoes(dadosInteracoes);
    });

    setCarregando(false);

    onRefresh();
    return alert.success('Dados gravados.', { timeout: 5000 });
  };

  const enviarOpiniao = async () => {
    setCarregando(true);

    if (values.Nota === '') {
      setCarregando(false);
      return (
        alert.error('Por favor, selecione uma nota para avaliar o atendimento.', { timeout: 5000 })
      );
    }

    if (values.Justificativa === '') {
      setCarregando(false);
      return (
        alert.error('Por favor, preencha sua opinião para avaliar o atendimento.', { timeout: 5000 })
      );
    }

    const resposta = await postOpinar({
      ...values,
      IdOuvidoria: id,
    });

    if (resposta.Error) {
      setCarregando(false);
      return (
        alert.error('Aconteceu um erro inesperado. Tente novamente.', { timeout: 5000 })
      );
    }

    setCarregando(false);
    onRefresh();
    return alert.success('Agradecemos muito sua opinião, ela é essencial para nosso trabalho.', { timeout: 5000 });
  };

  const enviarOpiniaoCancelada = async () => {
    setCarregando(true);
    const resposta = await postOpinar({
      ...values,
      Nota: '',
      LikeUnlike: '',
      Justificativa: 'Usuário não opinou.',
      IdOuvidoria: id,
    });

    if (resposta.Error) {
      setCarregando(false);
      return (
        alert.error('Aconteceu um erro inesperado. Tente novamente.', { timeout: 5000 })
      );
    }

    setCarregando(false);
    onRefresh();

    return true;
  };

  useEffect(() => {
    if (aberto) {
      if (andamentos && andamentos.length > 0) {
        andamentos.map((andamento) => (postAtualizarVisualizadoManifestacao(andamento.Id)));
      }

      if (listaInteracoes && listaInteracoes.length > 0) {
        listaInteracoes.map((interacao) => (postAtualizarVisualizadoInteracaoManifestacao(interacao.Id)));
      }
    }
  }, [aberto]);

  return (
    <>
      <ListaItem className="controle-fundo">
        <ListaItemHeader onClick={() => setAberto(!aberto)}>
          <Linha style={{ alignSelf: 'center', paddingRight: 5 }}>
            {likeUnlike === 'L' && (
              <img src={LikePng} style={{ height: 17, width: 17, marginRight: 5 }} alt="Gostei" />
            )}
            {likeUnlike === 'U' && (
              <img src={UnlikePng} style={{ height: 17, width: 17, marginRight: 5 }} alt="Não gostei" />
            )}
            {(arquivos && arquivos.length > 0) && (
            <AnexoSvg
              height={17}
              width={17}
              fill="#777"
              style={{ alignSelf: 'center', marginRight: 5 }}
              marginRight={espacamento.extraPequeno}
            />
            )}
            <b style={{ marginRight: 5 }}>Protocolo:</b>
            <span style={{ marginRight: 10 }}>{id}</span>
            <DataTexto>{dataHora}</DataTexto>
          </Linha>

          <span style={{ maxWidth: 300, alignSelf: 'center' }}>
            <b style={{ marginRight: 5 }}>Secretaria:</b>
            <span>{secretaria}</span>
          </span>
        </ListaItemHeader>

        {aberto && (
          <ListaItemBody>
            <Linha>
              <b style={{ marginRight: 10 }}>Assunto:</b>
              <span>{assunto}</span>
              <Linha style={{ justifyContent: 'flex-end' }}>
                {(getTotem() !== 'true') && (
                  <Botao
                    impressao
                    onClick={() => dispatch(abrirModalImpressaoZeladoria({
                      arquivos,
                      id,
                      secretaria,
                      dataHora,
                      assunto,
                      endereco,
                      numero,
                      bairro,
                      descricao,
                      andamentos,
                      likeUnlike,
                      status,
                      listaInteracoes,
                    }))}
                    label="Ir para impressão"
                  />
                )}

              </Linha>
            </Linha>

            {unidade && (
              <Linha>
                <b style={{ marginRight: 10 }}>Unidade:</b>
                <span>{unidade}</span>
              </Linha>
            )}

            <Linha>
              <b style={{ marginRight: 10 }}>Endereço:</b>
              <span>{endereco}</span>
              {(numero) && (
                <>
                  <span>&nbsp;nº&nbsp;</span>
                  <span>{numero}</span>
                </>
              )}
            </Linha>

            <Linha>
              <b style={{ marginRight: 10 }}>Bairro:</b>
              <span>{bairro}</span>
            </Linha>

            <Divisor size="ultraPequeno" />

            <div>
              <b>Descrição:</b>
            </div>

            <Divisor size="ultraPequeno" />

            <PerguntaRespostaZeladoria className="controle-fundo">
              <span>{replaceTags(descricao)}</span>
            </PerguntaRespostaZeladoria>

            {andamentos && andamentos.length > 0 && (
              <>
                <Divisor size="ultraPequeno" />

                <div>
                  {(status === 'Concluído' || status === 'Cancelado') && andamentos.length === 1
                    && (
                    <>
                      <b>Resposta Final:</b>

                      <div key={andamentos[0].Historico}>
                        <Linha style={{ justifyContent: 'space-between' }}>
                          <small style={{ textTransform: 'capitalize' }}>{andamentos[0].Nome.toLowerCase()}</small>
                          <DataTexto style={{ fontSize: '0.8em' }}>{andamentos[0].DataHora}</DataTexto>
                        </Linha>
                        <PerguntaRespostaZeladoria className="controle-fundo">
                          <div style={{ marginInline: 5 }} dangerouslySetInnerHTML={{ __html: andamentos[0].Historico }} />
                          {/* <span>{replaceTags(andamentos[0].Historico)}</span> */}
                        </PerguntaRespostaZeladoria>

                        <Divisor size="ultraPequeno" />
                      </div>
                    </>
                    )}

                  {(status === 'Concluído' || status === 'Cancelado') && andamentos.length > 1
                    && (
                    <>
                      <b>Andamentos:</b>

                      {andamentos.slice(1).map(({ Historico, DataHora, Nome }) => (
                        <div key={Historico}>
                          <Linha style={{ justifyContent: 'space-between' }}>
                            <small style={{ textTransform: 'capitalize' }}>{Nome.toLowerCase()}</small>
                            <DataTexto style={{ fontSize: '0.8em' }}>{DataHora}</DataTexto>
                          </Linha>
                          <PerguntaRespostaZeladoria className="controle-fundo">
                            <div style={{ marginInline: 5 }} dangerouslySetInnerHTML={{ __html: Historico }} />
                            {/* <span>{replaceTags(Historico)}</span> */}
                          </PerguntaRespostaZeladoria>

                          <Divisor size="ultraPequeno" />
                        </div>
                      ))}

                      <Divisor size="ultraPequeno" />

                      <b>Resposta Final:</b>

                      <div key={andamentos[0].Historico}>
                        <Linha style={{ justifyContent: 'space-between' }}>
                          <small style={{ textTransform: 'capitalize' }}>{andamentos[0].Nome.toLowerCase()}</small>
                          <DataTexto style={{ fontSize: '0.8em' }}>{andamentos[0].DataHora}</DataTexto>
                        </Linha>
                        <PerguntaRespostaZeladoria className="controle-fundo">
                          <div style={{ marginInline: 5 }} dangerouslySetInnerHTML={{ __html: andamentos[0].Historico }} />
                          {/* <span>{replaceTags(andamentos[0].Historico)}</span> */}
                        </PerguntaRespostaZeladoria>

                        <Divisor size="ultraPequeno" />
                      </div>
                    </>
                    )}

                  {status !== 'Concluído' && status !== 'Cancelado'
                    && (
                    <>
                      <b>Andamentos:</b>

                      {andamentos.map(({ Historico, DataHora, Nome }) => (
                        <div key={Historico}>
                          <Linha style={{ justifyContent: 'space-between' }}>
                            <small style={{ textTransform: 'capitalize' }}>{Nome.toLowerCase()}</small>
                            <DataTexto style={{ fontSize: '0.8em' }}>{DataHora}</DataTexto>
                          </Linha>
                          <PerguntaRespostaZeladoria className="controle-fundo">
                            <div style={{ marginInline: 5 }} dangerouslySetInnerHTML={{ __html: Historico }} />
                            {/* <span>{replaceTags(Historico)}</span> */}
                          </PerguntaRespostaZeladoria>

                          <Divisor size="ultraPequeno" />
                        </div>
                      ))}
                    </>
                    )}
                </div>
              </>
            )}

            {listaInteracoes && listaInteracoes.length > 0 && (
              <>
                <Divisor size="ultraPequeno" />

                <div>
                  <b>Interações:</b>
                </div>

                {listaInteracoes && listaInteracoes.map((itemInteracao) => (
                  <div key={itemInteracao && itemInteracao.Interacao}>
                    <Linha style={{ justifyContent: 'space-between' }}>
                      <small style={{ fontSize: '0.8em', textTransform: 'capitalize' }}>
                        {(itemInteracao && itemInteracao.Administrador)
                          ? ((itemInteracao && itemInteracao.Administrador) && ((itemInteracao && itemInteracao.Administrador.toLowerCase())))
                          : (itemInteracao && itemInteracao.Solicitante) && (itemInteracao && itemInteracao.Solicitante.toLowerCase())}
                      </small>
                      <DataTexto style={{ fontSize: '0.8em' }}>{itemInteracao && itemInteracao.DataHora}</DataTexto>
                    </Linha>
                    <PerguntaRespostaZeladoria className="controle-fundo">
                      <div style={{ marginInline: 5 }} dangerouslySetInnerHTML={{ __html: itemInteracao && itemInteracao.Interacao }} />
                      {/* <span>{replaceTags(itemInteracao && itemInteracao.Interacao)}</span> */}
                    </PerguntaRespostaZeladoria>

                    <Divisor size="ultraPequeno" />
                  </div>
                ))}
              </>
            )}

            {listaInteracoes && !listaInteracoes.Message && listaInteracoes[0].Administrador && (status === 'Aberto' || status === 'Pendente' || status === 'Em andamento' || status === 'Agendado') && (
            <>
              <FormControl
                label="Responder interação:"
                value={values.Interacao}
                onChange={({ target }) => setValues({
                  ...values,
                  Interacao: target.value,
                })}
                type="textarea"
              />
              {(getTotem() !== 'true') && (
              <FormControl
                type="arquivo2"
                dadosArquivos={fotos}
                onDrop={adicionarArquivo}
                onDropRejected={ExibirErroTamanhoArquivo}
                onRemove={removerArquivo}
              />
              )}
              <Divisor />

              <FormFooter>
                {carregando !== true
                  ? (
                    <Botao
                      label="Enviar"
                      onClick={enviarInteracao}
                    />
                  )
                  : (
                    <Carregar />
                  )}
              </FormFooter>
            </>
            )}

            {((dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') && likeUnlike === 'N' && (status === 'Concluído' || status === 'Cancelado') && numeroDeDias < 30) && (
              <>
                <div>
                  <b>Avaliação:</b>
                </div>

                <Divisor />

                <FormFooter style={{ gap: 1, justifyContent: 'flex-start' }}>
                  <div style={{ width: '100%' }}>
                    <b>Sua manifestação foi resolvida?</b>
                    <FormControl
                      label=""
                      nameRadio="likeUnLike"
                      idRadio="radioSimLikeUnlike"
                      valueRadio="L"
                      labelRadio="Sim"
                      changeRadio={({ target }) => setVal('LikeUnlike', target.value)}
                      idRadio2="radioNaoLikeUnlike"
                      valueRadio2="U"
                      labelRadio2="Não"
                      changeRadio2={({ target }) => setVal('LikeUnlike', target.value)}
                      checkedRadio
                      type="radioLikeUnlike"
                    />
                    <div className="container">
                      <b style={{ display: 'block', marginBottom: '10px' }}>Avaliação do atendimento da zeladoria:</b>
                      <div id="widget" className="widget">
                        <BotaoRps type="button" value="0" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="vermelho">0</BotaoRps>
                        <BotaoRps type="button" value="1" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="vermelho">1</BotaoRps>
                        <BotaoRps type="button" value="2" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="vermelho">2</BotaoRps>
                        <BotaoRps type="button" value="3" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="vermelho">3</BotaoRps>
                        <BotaoRps type="button" value="4" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="laranja">4</BotaoRps>
                        <BotaoRps type="button" value="5" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="laranja">5</BotaoRps>
                        <BotaoRps type="button" value="6" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="amarelo">6</BotaoRps>
                        <BotaoRps type="button" value="7" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="amarelo">7</BotaoRps>
                        <BotaoRps type="button" value="8" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="verde">8</BotaoRps>
                        <BotaoRps type="button" value="9" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="verde">9</BotaoRps>
                        <BotaoRps type="button" value="10" onClick={({ target }) => { setVal('Nota', target.value); preencheRps(target); }} className="verde">10</BotaoRps>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                </FormFooter>

                <Divisor />

                <FormControl
                  label="Comentário"
                  value={values.Justificativa}
                  onChange={({ target }) => setVal('Justificativa', target.value)}
                  type="textarea"
                />

                <Divisor />

                <FormFooter>
                  {carregando !== true
                    ? (
                      <>
                        <Botao
                          cancelar
                          style={{ backgroundColor: '#e56b6b', marginRight: '10px' }}
                          label="Cancelar"
                          onClick={enviarOpiniaoCancelada}
                        />
                        <Botao
                          label="Enviar"
                          onClick={enviarOpiniao}
                        />

                      </>
                    )
                    : (
                      <Carregar />
                    )}
                </FormFooter>
              </>
            )}

            {arquivos && (
            <>
              <Divisor />

              <Grid>
                {arquivos && arquivos.map((arquivo) => {
                  if (arquivo.Valor.endsWith('mp3') || arquivo.Valor.endsWith('aac') || arquivo.Valor.endsWith('ogg')) {
                    return (
                      <GridBotao
                        key={arquivo.Valor}
                        onClick={() => {
                          dispatch(abrirModalArquivo());
                          dispatch(selecionarArquivo({
                            type: 'audio/mp3',
                            preview: arquivo.Valor,
                          }));
                        }}
                        img={AudioPng}
                        type="arquivo"
                      />
                    );
                  }
                  if (arquivo.Valor.endsWith('mp4') || arquivo.Valor.endsWith('mov')) {
                    return (
                      <GridBotao
                        key={arquivo.Valor}
                        onClick={() => {
                          dispatch(abrirModalArquivo());
                          dispatch(selecionarArquivo({
                            type: 'video/mp4',
                            preview: arquivo.Valor,
                          }));
                        }}
                        img={VideoPng}
                        type="arquivo"
                      />
                    );
                  }
                  if (arquivo.Valor.endsWith('pdf')) {
                    return (
                      <GridBotao
                        key={arquivo.Valor}
                        onClick={() => {
                          dispatch(abrirModalArquivo());
                          dispatch(selecionarArquivo({
                            type: 'application/pdf',
                            preview: arquivo.Valor,
                          }));
                        }}
                        img={PdfPng}
                        type="arquivo"
                      />
                    );
                  }
                  if (arquivo.Valor.endsWith('zip')) {
                    return (
                      <GridBotao
                        key={arquivo.Valor}
                        img={ZipPng}
                        type="arquivo"
                        onClick={() => {
                          window.location.href = arquivo.Valor;
                        }}
                      />
                    );
                  }
                  if (arquivo.Valor.endsWith('rar')) {
                    return (
                      <GridBotao
                        key={arquivo.Valor}
                        img={RarPng}
                        type="arquivo"
                        onClick={() => {
                          window.location.href = arquivo.Valor;
                        }}
                      />
                    );
                  }
                  return (
                    <GridBotao
                      key={arquivo.Valor}
                      onClick={() => {
                        dispatch(abrirModalArquivo());
                        dispatch(selecionarArquivo({
                          type: 'image/jpeg',
                          preview: arquivo.Valor,
                        }));
                      }}
                      img={arquivo.Valor}
                      type="arquivo"
                    />
                  );
                })}
              </Grid>
            </>
            )}

          </ListaItemBody>
        )}
      </ListaItem>

      <Divisor />
    </>
  );
};

ListaZeladorias.propTypes = {
  arquivos: PropTypes.oneOfType([PropTypes.array]).isRequired,
  andamentos: PropTypes.oneOfType([PropTypes.array]).isRequired,
  id: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  secretaria: PropTypes.string.isRequired,
  dataHora: PropTypes.string.isRequired,
  assunto: PropTypes.string,
  unidade: PropTypes.string,
  bairro: PropTypes.string,
  descricao: PropTypes.string,
  likeUnlike: PropTypes.string,
  onRefresh: PropTypes.func,
  endereco: PropTypes.string,
  numero: PropTypes.string,
  dataHoraCanceladoConcluido: PropTypes.string,
};

ListaZeladorias.defaultProps = {
  assunto: null,
  bairro: null,
  descricao: null,
  likeUnlike: null,
  onRefresh: null,
  endereco: null,
  numero: null,
  unidade: null,
  dataHoraCanceladoConcluido: null,
};

export default ListaZeladorias;
